var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_443_4338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 1.6665H17.9167V17.9171H1.66699V1.6665Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_443_4338)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.31116 9.66518C7.32616 9.67852 7.34033 9.69102 7.35449 9.70602C8.25366 10.6277 8.74949 11.8485 8.74949 13.1444V16.4643L10.6128 15.4494C10.7595 15.3693 10.8503 15.2127 10.8503 15.0402V13.1343C10.8503 11.8435 11.3412 10.6268 12.232 9.71018L16.2628 5.42268C16.5237 5.14518 16.667 4.78102 16.667 4.39685V3.61685C16.667 3.23018 16.362 2.91602 15.9887 2.91602H3.59616C3.22199 2.91602 2.91699 3.23018 2.91699 3.61685V4.39685C2.91699 4.78102 3.06033 5.14518 3.32116 5.42185L7.31116 9.66518ZM8.45533 17.9169C8.28699 17.9169 8.12033 17.8719 7.96866 17.7819C7.67533 17.6069 7.49949 17.2977 7.49949 16.9544V13.1444C7.49949 12.1985 7.14699 11.3077 6.50449 10.6252C6.48533 10.6094 6.46616 10.5919 6.44949 10.5735L2.41116 6.27935C1.93116 5.76935 1.66699 5.10018 1.66699 4.39685V3.61685C1.66699 2.54102 2.53283 1.66602 3.59616 1.66602H15.9887C17.0512 1.66602 17.917 2.54102 17.917 3.61685V4.39685C17.917 5.09935 17.6528 5.76768 17.1745 6.27852L13.1353 10.5735C12.4662 11.2635 12.1003 12.171 12.1003 13.1344V15.0402C12.1003 15.6702 11.7595 16.2469 11.2112 16.5469L8.91033 17.8002C8.76699 17.8777 8.61116 17.9169 8.45533 17.9169Z",
    fill: "#667085"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.b900034f.svg";
export { ForwardRef as ReactComponent };